import {Spin} from "antd";
import React from "react";

export const AnalyticsSpinner = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%'
  }}>
    <Spin size='large' />
  </div>
)
